import { Component, OnInit, inject } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { UserService } from '../../../../services/user/user.service';
import { UserBonusesService } from '../../../../services/user/user-bonuses.service';
import { filter, tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { InstallAppService } from '../../../../services/install-app.service';
import { PwaService } from '../../../../services/pwa.service';
import { NotificationCenterComponent } from '../notification-center/notification-center.component';
import { ClickOutsideDirective } from '../../../directives/click-outside.directive';
import { NgClass, AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-notification-sidebar',
  templateUrl: './notification-sidebar.component.html',
  styleUrls: ['./notification-sidebar.component.scss'],
  imports: [NgClass, ClickOutsideDirective, NotificationCenterComponent, AsyncPipe],
})
export class NotificationSidebarComponent implements OnInit {
  notify = inject(NotificationCenterService);
  private _user = inject(UserService);
  private _bonuses = inject(UserBonusesService);
  private _installApp = inject(InstallAppService);
  private _pwa = inject(PwaService);


  ngOnInit(): void {
    this._initInstallForNotification();
  }

  /**
   * Init install notification for notification center
   * @private
   */
  private _initInstallForNotification() {
    this._pwa.isEnabled$.pipe(
      filter(() => !this._installApp.isNativeApp),
      tap((data) => {
        if (this._installApp.showInstallAppNotificationMessage) {
          this.notify.installAppChannel$.next(true);
          this._installApp.showInstallAppNotificationMessage = false;
        } else if (!data) {
          const installApp = this.notify.notifications$.getValue().find((e) => e.notify_channel === this.notify.customChannels.INSTALL_APP);
          if (installApp) {
            this.notify.removeNotify(installApp);
            this.notify.close();
          }
        }
      }),
    ).subscribe();
  }
}
